import { render, staticRenderFns } from "./businesses-snippet.vue?vue&type=template&id=671eed54&"
import script from "./businesses-snippet.vue?vue&type=script&lang=js&"
export * from "./businesses-snippet.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports